<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         version="1.2"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="21"
         height="19">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" style="fill: rgba(18, 18, 18, 0.99);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ArrowRightSVG"
    }
</script>

<style scoped>

</style>